import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { take } from "rxjs/operators";
import LevelOfCare from "../../models/patient-chart/levelOfCare";
import Page from "../../pages/patient-chart/level-of-care/models/LevelOfCareHistoryPage";
import { ConfigurationService } from "../configuration/configuration.service";
import { FacilitiesService } from "../facilities-service/facilities.service";

@Injectable()
export class LevelOfCareProvider {
  levelOfCareUrl: string;
  headers: HttpHeaders;
  constructor(
    public http: HttpClient,
    private toastCtrl: ToastController,
    private facilityService: FacilitiesService,
    private config: ConfigurationService
  ) {
    this.levelOfCareUrl = this.config.resolvePatientChartsUrl();

    this.headers = new HttpHeaders().set("Content-Type", "application/json");
  }

  saveLevelOfCare(id: number, levelOfCare: LevelOfCare) {
    if (levelOfCare.id && levelOfCare.id > 0) {
      return this.http.put(
        `${this.levelOfCareUrl}/patient-charts/${id}/level-of-care`,
        levelOfCare
      );
    } else {
      return this.http.post(
        `${this.levelOfCareUrl}/patient-charts/${id}/level-of-care`,
        levelOfCare
      );
    }
  }

  getLevelOfCareHistory(
    id: number,
    currentPage,
    pageLimit,
    orderBy,
    sortBy,
    newBillingFacilityToggle
  ): Observable<Page> {
    let lookupUrl = `${this.levelOfCareUrl}/patient-charts/${id}/level-of-care-history?page=${currentPage}&limit=${pageLimit}&direction=${orderBy}&sortBy=${sortBy}&facilityToggle=${newBillingFacilityToggle}`;
    return this.http.get<Page>(lookupUrl).pipe(take(1));
  }

  deleteLevelOfCare(id: any, patientChartId: string) {
    let url: string = `${this.levelOfCareUrl}/patient-charts/${patientChartId}/level-of-care/${id}`;
    return new Observable((observer) => {
      this.http.delete(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next({ data, patientChartId });
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/levelOfCareService.ts